export const getNetworkAccessList = () => {
  return [
    {
      mode: "infra",
      bssid: "11:22:33:44:04:12",
      channel: 6,
      bitrate: 130,
      secured: true,
      signal: 74,
      ssid: "Home WIFI",
      rsn_flags: 392,
    },
    {
      mode: "infra",
      bssid: "11:22:33:44:04:12",
      channel: 6,
      bitrate: 130,
      secured: true,
      signal: 92,
      ssid: "Net123",
      rsn_flags: 392,
    }
  ];
};

export const getNetworkSettings = () => {
  return {
    settings: {
      modem: {
        name: "GSM",
        autoconnect: false,
        interface: "cdc-wdm0",
        apn: "telstra.m2m",
      },
      wifi: {
        method: "auto",
        netmask: null,
        ip: null,
        dns: [],
        name: "WiFi",
        interface: "mlan0",
        ssid: "Home WIFI",
        gateway: null,
        primary: true,
      },
      ethernet: {
        method: "auto",
        netmask: null,
        ip: null,
        dns: [],
        name: "Ethernet",
        interface: "eth0",
        gateway: null,
        primary: false,
      },
    },
    status: {
      modem: {
        reason: "none",
        state: "disconnected",
        interface: "cdc-wdm0",
        type: "modem",
        signal: 2,
        mac: null,
        primary: false,
      },
      ethernet: {
        reason: "none",
        netmask: "255.255.255.0",
        ip: "192.168.1.2",
        dns: ["192.168.1.1"],
        state: "activated",
        interface: "eth0",
        type: "ethernet",
        signal: 5,
        gateway: "192.168.1.1",
        mac: "11:22:33:44:8D:60",
        primary: false,
      },
      wifi: {
        reason: "none",
        netmask: "255.255.255.0",
        ip: "192.168.1.2",
        dns: ["192.168.1.1"],
        state: "activated",
        interface: "mlan0",
        type: "wifi",
        signal: 5,
        gateway: "192.168.1.1",
        mac: "11:22:33:44:55:8A",
        primary: true,
      },
      success: true,
      hotspot: {
        reason: "none",
        netmask: "255.255.255.240",
        ip: "192.168.1.1",
        dns: [],
        state: "activated",
        interface: "uap0",
        type: "wifi",
        signal: 5,
        gateway: "0.0.0.0",
        mac: "11:22:33:44:55:8A",
        primary: false,
      },
      status: {
        ethernet: {
          reason: "now_managed",
          state: "unavailable",
          interface: "eth0",
          type: "ethernet",
          signal: 0,
          mac: "11:22:33:44:55:8A",
        },
        modem: {
          reason: "none",
          state: "disconnected",
          interface: "cdc-wdm0",
          type: "modem",
          signal: 1,
          mac: null,
        },
        wifi: {
          reason: "none",
          netmask: "255.255.255.0",
          ip: "192.168.1.2",
          dns: ["192.168.1.1"],
          state: "activated",
          interface: "mlan0",
          type: "wifi",
          signal: 5,
          mac: "11:22:33:44:55:8A",
          gateway: "192.168.1.1",
        },
      },
      last_message: 1742635493,
      message: "WiFi Access Point list updated",
    },
  };
};
